var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"darken-1",attrs:{"block":"","outlined":"","color":"red","dark":""},on:{"click":_vm.googleAuth}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-google")]),_vm._v("Continue with Google ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }